import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const LineChartComponent = ({ data }) => {
  // Sort data by date (so that months appear in correct order)
  const sortedData = [...data].sort(
    (a, b) => new Date(a.start) - new Date(b.start)
  );

    // Helper: format month into 3 letters (Jan, Feb, etc.)
    const formatMonth = (month) => {
        const date = new Date(month);
        return date.toLocaleString("en-US", { month: "short" }); // "Jan", "Feb", ...
      };

  return (
    <div style={{ width: "100%", height: 200 }}>
      <ResponsiveContainer>
        <LineChart
          data={sortedData}
          margin={{ top: 20, right: 30, left: 10, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="month"
            tickFormatter={formatMonth}
            tick={{ fontSize: 12 }}
            textAnchor="end"
            interval={0}
          />
          <YAxis />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#FF6600" // Orange line
            strokeWidth={3}
            dot={{ r: 5, stroke: "#FF6600", strokeWidth: 2, fill: "#fff" }}
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartComponent;
